module.exports = "/_next/static/images/d2234fcef7e6b92a2e45064c69ebe8a5-nubanker-eng@0.75x.jpg.webp";